import PopupManagePartners from './PopupManagePartners';

export default PopupManagePartners;
